import { OrgTypeEnum } from "~/typings/types";

const configCrmNameByOrgType = {
	[OrgTypeEnum.SelfEmployed]: "ФИО СМЗ",
	[OrgTypeEnum.IndividualEntrepreneur]: "ФИО ИП",
	[OrgTypeEnum.Company]: "ФИО Ген. директора",
}

export const getCrmNameByOrgType = (orgType: OrgTypeEnum) => configCrmNameByOrgType[orgType];